"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoCoursesAssigned = exports.UnderConstructionPageBanner = exports.WelcomePageBanner = exports.NoCoursesAssignedArgs = exports.UnderConstructionPageBannerArgs = exports.WelcomePageBannerArgs = void 0;
var react_1 = __importDefault(require("react"));
var get_component_1 = require("../../shared/helpers/get-component");
var il_navigation_banner_1 = __importDefault(require("./il-navigation-banner"));
var AppleAndPencils_png_1 = __importDefault(require("../../assets/images/AppleAndPencils.png"));
var Backpack_svg_1 = __importDefault(require("../../assets/images/Backpack.svg"));
// arguments
exports.WelcomePageBannerArgs = {
    title: 'Welcome!',
    description: (react_1.default.createElement(react_1.default.Fragment, null,
        "Looks like you haven\u2019t set up any students yet,",
        react_1.default.createElement("br", null),
        " add some students to your school to get started")),
    actionText: 'Add Students',
    imageSrc: AppleAndPencils_png_1.default,
};
exports.UnderConstructionPageBannerArgs = {
    title: 'Under Construction',
    description: function (_a) {
        var product = _a.product;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            "This page is under construction. Please hit back button to go back or you",
            react_1.default.createElement("br", null),
            "can go to the legacy version of ",
            product || '[product]',
            " by clicking the button below"));
    },
    actionText: 'Planner (legacy website)',
    imageSrc: AppleAndPencils_png_1.default,
};
exports.NoCoursesAssignedArgs = {
    subtitle: 'You don’t have any courses assigned yet!',
    description: (react_1.default.createElement(react_1.default.Fragment, null,
        "Your courses will appear here after they are",
        react_1.default.createElement("br", null),
        "assigned by your teacher.")),
    imageSrc: Backpack_svg_1.default,
};
// components
exports.WelcomePageBanner = (0, get_component_1.getComponent)(il_navigation_banner_1.default, exports.WelcomePageBannerArgs);
exports.UnderConstructionPageBanner = (0, get_component_1.getComponent)(il_navigation_banner_1.default, exports.UnderConstructionPageBannerArgs);
exports.NoCoursesAssigned = (0, get_component_1.getComponent)(il_navigation_banner_1.default, exports.NoCoursesAssignedArgs);
